export const changeRAndDUpperCase = (dealType: string) => {
  return dealType.replace("r&d", "R&D");
};

export const changeDealTypeForDisplay = (dealType: string) => {
  if (dealType === "cross license agreement")
    return "License Agreement(Cross License)";

  const withUpperCaseRAndD = dealType.replace("r&d", "R&D");
  return withUpperCaseRAndD
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};
